<template>
  <div>
    <v-marker-cluster>
      <l-marker
        v-for="(latlng, i) in latLngs"
        :key="i"
        :icon="defaultIcon"
        :lat-lng="[latlng.lat, latlng.lng]"
      />
    </v-marker-cluster>
  </div>
</template>

<script>
import { LMarker } from "vue2-leaflet";
import L from "leaflet";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "leaflet/dist/leaflet.css"
import icon from "@/assets/marker-icon-2x.png";
import iconShadow from "@/assets/marker-shadow.png";

export default {
  components: {
    LMarker,
    "v-marker-cluster": Vue2LeafletMarkerCluster,
  },
  props: {
    latLngs: {
      type: Array,
      default: () => [],
      custom: false,
    },
  },
  data() {
    return {
      defaultIcon: L.icon({
        iconUrl: icon,
        iconSize: [26, 42],
        iconAnchor: [13, 42],
        shadowUrl: iconShadow,
        shadowSize: [41, 41],
        shadowAnchor: [13, 41],
      }),
    };
  },
};
</script>
